import {Query} from "../HealthcareUsageReport/types/CohortQuery";
import _ from "lodash";

export const RUNNING_STATUS = "running";
export const FINISHED_STATUS = "finished";
export const FAILED_STATUS = "failed";
export const WAITING_STATUS = "waiting";
export const QUEUE_STATUS = "queue";
export const KILLED_STATUS = "killed";
export const SUBMITTED_STATUS = "submitted";

const RUNNING_STATUSES = [
    RUNNING_STATUS, WAITING_STATUS, QUEUE_STATUS, SUBMITTED_STATUS
]

const DONE_STATUSES = [
    FINISHED_STATUS, FAILED_STATUS, KILLED_STATUS
]

export const isRunning = (study: Query) => {
    const sparkQuery = study.sparkQuery;
    if (sparkQuery && sparkQuery.active) {
        return _.isNil(sparkQuery.status) || RUNNING_STATUSES.includes(sparkQuery.status.toLowerCase())
    }
    return false
}

export const isFinished = (study: Query) => {
    const hasInactiveSparkQuery = study?.sparkQuery && !study.sparkQuery.active
    return hasInactiveSparkQuery || DONE_STATUSES.includes((study?.sparkQuery?.status ?? '').toLowerCase())
}